import { render, staticRenderFns } from "./LocationDialog.vue?vue&type=template&id=bc6022b8"
import script from "./LocationDialog.vue?vue&type=script&lang=ts"
export * from "./LocationDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports